import Vue from 'vue'
import Vuex from 'vuex'

import device from './modules/device'
import createSocio from './modules/createSocio'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        device,
        createSocio
    }
})
